import script from "./SapitoView.vue?vue&type=script&setup=true&lang=js"
export * from "./SapitoView.vue?vue&type=script&setup=true&lang=js"

import "./SapitoView.vue?vue&type=style&index=0&id=6e590e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e590e78"]])

export default __exports__